import React, { useEffect, useRef, useState } from "react";

import { Modal } from "antd";
import { clearStoragePreservingReportColumns } from "../../utilities/reportColumnStorage";

const InactivityHandler = () => {
  const [showWarning, setShowWarning] = useState(false);
  const timeoutRef = useRef(null);
  const warningRef = useRef(null); //timer to show warning before logout
  const isLoggedIn = !!localStorage.getItem('token');

  const logoutUser = () => {
    clearStoragePreservingReportColumns();
    setShowWarning(false);
    window.location.href = "/"; //redirects to login page
  };

  const resetTimer = () => {
    clearTimeout(timeoutRef.current);
    clearTimeout(warningRef.current);
    setShowWarning(false);

    warningRef.current = setTimeout(() => {
      setShowWarning(true);
    }, 28 * 60 * 1000);

    timeoutRef.current = setTimeout(() => {
      logoutUser();
    }, 30 * 60 * 1000);
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    const activityEvents = ["click", "mousemove", "keydown", "scroll", "touchstart"];
    activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); // Initialize on mount

    return () => {
      activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timeoutRef.current);
      clearTimeout(warningRef.current);
    };
  }, [isLoggedIn]);

  return (
    <>
      {isLoggedIn && (
    <Modal open={showWarning} footer={null} closable={false} centered title="Warning:">
      <p>You will be logged out in 2 minutes due to inactivity.</p>
    </Modal>
    )}
    </>
  );
};

export default InactivityHandler;